import * as React from 'react';
import {
  Platform,
  KeyboardAvoidingView,
  StyleSheet,
  View,
  ScrollView,
  Text
} from 'react-native';
import { translate } from 'secullum-i18n';
import { Card, Modal, isTablet } from 'secullum-react-native-ui';
import { getTheme } from '../../shared/modules/layout';
import { DadosFuncionario } from '../modules/types';
import SolicitarAjudaForm from './SolicitarAjudaForm';

interface Props {
  dadosFuncionario?: DadosFuncionario;
  empresaBancoId: string;
  nomeEmpresa: string;
  caminhoTermoPrivacidade: string;
  onClose: () => void;
  onNavegar?: () => void;
  onErroConexao?: (mensagem: string, onTentarNovamente: () => void) => void;
}

class ModalSolicitarAjuda extends React.Component<Props> {
  render() {
    const ios = Platform.OS === 'ios';

    return (
      <Modal visible onRequestClose={() => true}>
        {/*
          sec-issues#14678: No Android o behavior 'position' desloca o conteúdo inteiro
          para cima ao abrir o teclado, e como o container é mais alto que a janela o
          topo do modal saía da tela, levando junto o título. O 'height' reduz a altura
          disponível em vez de deslocar, então o ScrollView interno assume a rolagem e
          o topo continua visível.
          O keyboardVerticalOffset do Android era -100 para compensar esse deslocamento;
          como o 'height' não desloca nada, não há mais o que compensar.
        */}
        <KeyboardAvoidingView
          style={styles.container}
          behavior={ios ? 'padding' : 'height'}
          keyboardVerticalOffset={ios ? 30 : 0}
          enabled
        >
          <Card style={styles.modal}>
            <ScrollView>
              <Card.Section>
                <View style={styles.cardHeader}>
                  <Text style={styles.title}>
                    {translate('Solicitar Ajuda')}
                  </Text>
                </View>
                <SolicitarAjudaForm {...this.props} />
              </Card.Section>
            </ScrollView>
          </Card>
        </KeyboardAvoidingView>
      </Modal>
    );
  }
}

const theme = getTheme();

const cardMargin = 20;

const styles = StyleSheet.create({
  cardHeader: {
    paddingBottom: 10,
    flexDirection: 'row'
  },
  title: {
    flexDirection: 'row',
    fontSize: isTablet() ? 28 : 18,
    fontWeight: 'bold',
    color: theme.textColor3,
    alignSelf: 'flex-start'
  },
  modal: {
    // O espaçamento é margem, e não `top`, para que o layout desconte a altura do
    // card em vez de apenas deslocá-lo.
    margin: cardMargin,
    justifyContent: 'center',
    flexDirection: 'row'
  },
  container: {
    flex: 1
  }
});

export default ModalSolicitarAjuda;
